<template>
  <div>
    <el-dialog :visible.sync="consignorDialog" width="900px"  append-to-body  title="公司查询结果">
          <el-table
            border
            ref="tableRef"
            :data="list"
            height="350"
            tooltip-effect="dark"
            highlight-current-row
            @current-change="handleCurrentChange"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column prop="entname" label="公司全称"></el-table-column>
            <el-table-column prop="legalname" label="法人姓名"></el-table-column>
            <el-table-column prop="esdate" show-overflow-tooltip label="注册时间"></el-table-column>
          </el-table>
         <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChangeTotal"
                :current-page="currentPage"
                layout="total, sizes, prev, pager, next, jumper"
                :page-size="pageSize"
                :page-sizes="[30, 50, 100, 200]"
                :total="total">
              </el-pagination>
            </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button @click="consignorDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-------------- 二次确认 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </div>
</template>
<script>
// import pagination from '@/components/pagination'

import openOrClose from '@/components/OpenOrClose/index' // 二次确认
// import { queryAllCustomerListByClientId } from '@/api/customer/customerManage'
import {
  queryEnterQueryEinVo,
  queryByCusName,
  queryBySusName
} from '@/api/customer/customerManage'
export default {
  components: {
    'open-or-close-dialog': openOrClose
  },
  data () {
    return {
      dataCount: 'cuName',
      total: 0,
      message: [],
      supplierRules: {},
      list: [],
      params: {},
      isShow: '', // 名称
      title: '',
      formLabelAlign: {},
      pageSize: 200, // 页数
      currentPage: 1, // 页码
      content: '',
      loadingTable: false,
      consignorDialog: false,
      contractScreenCondition: [
        { label: '部门', value: 'orgName' },
        { label: '角色', value: 'roleName' },
        { label: '姓名', value: 'staffCnName' }
      ],
      withdrawalAppRuleform: {
        newValue: undefined
      }
    }
  },
  methods: {
    getList () {
      this.loadingTable = true
      this.list = []
      queryEnterQueryEinVo(
        this.currentPage,
        this.pageSize,
        this.formLabelAlign
      )
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            if (res.data.obj !== null) {
              this.list = res.data.obj.data.items
              this.total = res.data.obj.data.total
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 选中
    handleCurrentChange (val) {
      this.message = val
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleCurrentChangeTotal (val) {
      this.currentPage = val
      this.getList()
    },
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 发货管理退货申请提醒确认
    onUpdataState () {},
    // 验证客户名称是否重复
    onVerify () {
      if (this.dataCount === 'suName') {
        queryBySusName(this.message.entname)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('供应商名称验证通过')
              this.$emit('invoiceSearchDialog', this.message)
              this.consignorDialog = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        queryByCusName(this.message.entname)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('客户名称验证通过')
              this.$emit('invoiceSearchDialog', this.message)
              this.consignorDialog = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    onInitial (val, formLabelAlign, status) {
      this.dataCount = 'cuName'
      if (status === 'suName') {
        this.dataCount = 'suName'
      }
      this.isShow = val
      this.formLabelAlign = formLabelAlign
      this.consignorDialog = true
      this.getList()
      this.message = []
    },
    onSubmit () {
      if (this.message.length === 0) {
        this.$message.error('请选择公司')
      } else {
        this.$emit('invoiceSearchDialog', this.message)
        this.consignorDialog = false
      }
    }
  }
}
</script>

<style>
</style>
